import { DataBean } from "../DataBean";

export class AbstractAccountbypage extends DataBean {



    public async getAccountBypage(name: any, surname: any, regexStr: any, nit: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getAccount_String_String_String_Number_Number_Number", [name, surname, regexStr, nit, page, recordsPerPage]);
    }

    public async createAccount(entityType: number | null, docType: number | null, nit: number | null,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.bean.account.AbstractAccount_createAccount_Number_Number_Number", [entityType, docType, nit]);
    }

    public async updateAbstractAccount(abstractAccount: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.bean.account.AbstractAccount_updateAbstractAccount_com.advantage.bean.account.AbstractAccount", [
            {
                "DataBeanProperties": abstractAccount,
                "DataBeanName": "com.advantage.bean.account.AbstractAccount"
            }
        ]);
    }

}